import * as React from "react";
import { Spin } from 'antd';
export const Loading = (props) => {
    return (React.createElement("div", { style: containerStyle },
        React.createElement(Spin, { size: "large" })));
};
const containerStyle = {
    width: "100%",
    height: "50vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};
